exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2edZuvIk_cXkVfKk8FGr7L{width:310px}._143mTHbGUFQIwve5B63Iar{width:450px;max-width:500px}._2Fn8K4h9g9MtqFvoTKHJvL{color:var(--themePrimary)}.HmBrDhr8RKV7Yi-xoMhAF{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] ._1r_5hb_XsxBTycnFxQjSrm{border-radius:4px}", ""]);
// Exports
exports.locals = {
	"fixWidthContextMenuAdvanced": "_2edZuvIk_cXkVfKk8FGr7L",
	"fixWidthContextMenuSuggestion": "_143mTHbGUFQIwve5B63Iar",
	"unscheduleText": "_2Fn8K4h9g9MtqFvoTKHJvL",
	"innerContent": "HmBrDhr8RKV7Yi-xoMhAF",
	"buttonRadii": "_1r_5hb_XsxBTycnFxQjSrm"
};